import { IdentitySourceManager } from './IdentitySourceManager';

describe('IdentitySourceManager', () => {
  let sourceMan: IdentitySourceManager;

  const validDataSource = {
    userData: {
      email: 'testuser@gmail.com',
      firstName: 'John',
      lastName: 'Doe',
      contacts: [
        { type: 'home', number: '+1-876-1234-567' },
        { type: 'work', number: '+1-876-4321-765' }
      ]
    }
  };

  const emptyDataSource = {};

  it('should return the correct properties', () => {
    sourceMan = new IdentitySourceManager({
      identity: 'userData.email',
      properties: [
        { name: 'name', variable: 'userData.firstName' },
        { name: 'number', variable: 'userData.contacts.1.number' }
      ]
    });

    const identity = sourceMan.fetchIdentityData(validDataSource);
    expect(identity.identity).toBe('testuser@gmail.com');
    expect(identity.properties).not.toBe(undefined);
    expect(identity.properties?.name).toBe('John');
    expect(identity.properties?.number).toBe('+1-876-4321-765');
  });

  it('should return empty values', () => {
    sourceMan = new IdentitySourceManager({
      identity: 'userData.email',
      properties: [
        { name: 'name', variable: 'userData.firstName' },
        { name: 'number', variable: 'userData.contacts.1.number' }
      ]
    });

    const identity = sourceMan.fetchIdentityData(emptyDataSource);
    expect(identity.identity).toBe(undefined);
    expect(identity.properties).not.toBe(undefined);
  });
});
